import createRecursiveFunction from './createRecursiveFunction';

const createRecursiveFunctionForAnalytics = callback => {
  return createRecursiveFunction(callback, {
    condition: () => window && typeof window.ga === 'function',
  });
};

export default createRecursiveFunctionForAnalytics;
